import { err, setError } from 'actions/errors';

export function productNotFound() {
  return setError(err.PRODUCT_DETAILS, null, 404);
}
